<template>
  <div class="home">
    <div style="position:relative">
        <img
        class="banner"
        src="../assets/img/home/home_top.png"
        />
        <div class="divlight">
            <img class="light" src="../assets/img/scheme/icon_light.png"/>
            <div class="light_desc">
                <div class="name">客云云科技</div>
                <div class="desc">让经纪人生活更美好</div>
            </div>
            <div class="light_kf" @click="showKf">
              <img src="../assets/img/home/home_kf.png"/>
            </div>
        </div>
        <div class="search">
            <div class="search_title">
                <div class="dt">
                    <div style="margin-left:1rem;" class="dt1" @click="changeType('01')">
                        <div :class="'dt2'+ (data.searchType=='01'?' act':'')">查方案</div>
                        <div :class="'dt3'+ (data.searchType=='01'?' act':'')"></div>
                    </div>
                    <div class="dt4">
                        <div class="sp"></div>
                    </div>
                    <div class="dt1" @click="changeType('02')">
                        <div :class="'dt2'+ (data.searchType=='02'?' act':'')">查产品</div>
                        <div :class="'dt3'+ (data.searchType=='02'?' act':'')"></div>
                    </div>
                    <div class="dt4">
                        <div class="sp"></div>
                    </div>
                    <div class="dt1" @click="changeType('03')">
                        <div :class="'dt2'+ (data.searchType=='03'?' act':'')">查进度</div>
                        <div :class="'dt3'+ (data.searchType=='03'?' act':'')"></div>
                    </div>
                    
                </div>
            </div>
            <div class="fa">
                <div class="fa-div">
                    <img style="width:1.3rem;" src="../assets/img/home/icon_search.png"/>
                    <div @click="clickSearchTitle()" class="fa-div-label">请输入要查询的内容</div>
                    <!-- <van-field
                    v-model="data.searchTxt"
                    clearable
                    placeholder="请输入要查询的内容"
                    /> -->
                </div>
            </div>
        </div>
    </div>
    <!----------产品中心开始------------->
    <div class="con-title">
        <div class="con-title-detail">
          <span>产品中心</span>
        </div>
        <div class="con-title-detail-sub">全产品·全链条服务</div>
        <div class="con-title-bg-img">
            <div class="con-title-bg-img-img">
                <img src="../assets/img/home/icon_crown.png"/>
            </div>
            <div class="con-title-bg"></div>
        </div>
    </div>
    
    <div class="service">
      <div class="service-con">
        <div class="service-item bg1" @click="clickTypeFun('1')">
          <img src="../assets/img/index/icon_company.png"/>
          <div class="service-item-title">
            <div class="title1">企业经营贷</div>
            <div class="title2">额度高/易审批</div>
          </div>
        </div>

        <div class="service-item bg2 ml"  @click="clickTypeFun('2')">
          <img src="../assets/img/index/icon_people.png"/>
          <div class="service-item-title">
            <div class="title1">个人消费贷</div>
            <div class="title2">放款快/更安全</div>
          </div>
        </div>
      </div>
      <div class="service-con"  @click="clickTypeFun('3')" style="margin-top:0.5rem;">
        <div class="service-item bg3">
          <img src="../assets/img/index/icon_flow.png"/>
          <div class="service-item-title">
            <div class="title1">信用卡</div>
            <div class="title2">易申请/门槛低</div>
          </div>
        </div>

        <div class="service-item bg4 ml"  @click="clickTypeFun('4')">
          <img src="../assets/img/index/icon_lock.png"/>
          <div class="service-item-title">
            <div class="title1">车险</div>
            <div class="title2">合规渠道/产品全</div>
          </div>
        </div>
      </div>
    </div>
    <!----------产品中心结束------------->

    <!----------常用应用开始------------->
    <div class="con-title">
        <div class="con-title-detail">常用应用</div>
        <div class="con-title-bg-img">
            <div class="con-title-bg-img-img">
                <img src="../assets/img/home/icon_app.png"/>
            </div>
            <div class="con-title-bg"></div>
        </div>
    </div>

    <div class="app">
      <div class="app-con">
        <div class="app-item" @click="clickFun('1')">
          <img src="../assets/img/home/app_search.png"/>
          <div class="app-title">产品筛选</div>
        </div>
        <div class="app-sp"></div>
        <div class="app-item ml" @click="clickFun('2')">
          <img src="../assets/img/home/app_dest.png"/>
          <div class="app-title">匹配方案</div>
        </div>
        <div class="app-sp"></div>
        <div class="app-item ml" @click="clickFun('3')">
          <img src="../assets/img/home/app_shop.png"/>
          <div class="app-title">我的小店</div>
        </div>
        <div class="app-sp"></div>
        <div class="app-item ml" @click="showJjr()">
          <img src="../assets/img/home/app_hand.png"/>
          <div class="app-title">经纪人联盟</div>
        </div>
        <div class="app-sp"></div>
        <div class="app-item ml" @click="clickFun('5')">
          <img src="../assets/img/home/app_star.png"/>
          <div class="app-title">海报分享</div>
        </div>

        
      </div>
    </div>
   
    <!----------常用应用结束------------->

    <!----------热门产品开始------------->
    <div class="con-title">
        <div class="con-title-detail">热门产品</div>
        <div class="con-title-bg-img">
            <div class="con-title-bg-img-img">
                <img src="../assets/img/home/icon_hot.png"/>
            </div>
            <div class="con-title-bg"></div>
        </div>
    </div>

    <div class="match-center-type">
        <van-row style="margin-top:1rem;">
            <van-col span="6" class="match-center-type-type2"><div  @click="clickSearch('typeCode','')" :class="'btn'+ (search.typeCode==''?' sel':'')">全部贷款</div></van-col>
            <van-col span="18">
                <div class="match-center-type-type1">
                    <div class="match-center-type-type2">
                    <div @click="clickSearch('typeCode',item.type_code)" :class="'btn'+(search.typeCode==item.type_code?' sel':'')" v-for="item in data.typeList" :key="item.type_code">{{item.type_name}}</div>
                    </div>
                </div>
            </van-col>
        </van-row>

        <van-row style="margin-top:1rem;">
            <van-col span="6" class="match-center-type-type2"><div @click="clickSearch('orderType','')"  :class="'btn'+ (search.orderType==''?' sel':'')">综合排序</div></van-col>
            <van-col span="18">
                <div class="match-center-type-type1">
                    <div class="match-center-type-type2">
                    <div @click="clickSearch('orderType','01')" :class="'btn'+ (search.orderType=='01'?' sel':'')">按返佣</div>
                    <div @click="clickSearch('orderType','02')" :class="'btn'+ (search.orderType=='02'?' sel':'')">按利息</div>
                    <div @click="clickSearch('orderType','03')" :class="'btn'+ (search.orderType=='03'?' sel':'')">按额度</div>
                    </div>
                </div>
            </van-col>
        </van-row>
    </div>
    <!----------热门产品结束------------->
    
    <div class="match-product">
        <div class="match-product-item" @click="clickProductItem(item)" v-for="item in data.productList" :key="item.product_code">
            <div v-if="item.flag_hot=='1'" class="item-news">
                <div class="item-news-title">新</div>
            </div>
            <div class="item-top">
                <img class="item-top-img" :src="item.img_org"/>
                <div class="item-top-desc">
                    <div class="item-name">
                        <div class="item-name-name">{{item.product_name}}</div>
                        <!-- <div class="item-name-desc">立即进件 ></div> -->
                    </div>
                    <div class="item-hr"></div>
                    <div class="item-warn">最高{{item.money_max}}万</div>
                    <div class="item-prop">
                        <div class="item-prop-desc">
                            最高额度<a class="red">{{item.money_max}}万</a>
                        </div>
                        <div class="item-prop-desc">
                            年化利率<a class="black">{{item.rate_min}}% - {{item.rate_max}}%</a>
                        </div>
                        <div class="item-prop-desc">
                            贷款期限<a class="black">{{disLabel(item.times,"期")}}</a>
                        </div>
                    </div>
                    <div class="item-back">
                        <div class="item-back-desc" :key="sitem" v-for="sitem in JSON.parse(item.labels)">
                            {{sitem}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="background: rgb(239, 241, 242)">
      <div class="service">
        <div class="service-title2">客云云科技 · 让经纪人生活更美好</div>
        <div class="service-title3">移动办公 合规平台 专业服务</div>
      </div>
      <div style="height:100px;"></div>
    </div>
    <!----------菜单开始------------->
    <Menu :emodel="menuIndex"></Menu>

    <KfCard ref="kfcomp"></KfCard>
    <!----------菜单结束------------->
    <JjrCard ref="jjrcomp"></JjrCard>
    <ProductTipCard ref="producttipcomp"></ProductTipCard>
  </div>
</template>

<script setup>
import {} from 'vant';
import {ref,reactive,computed,watch,markRaw,defineProps,defineExpose} from "vue"
import Menu from '../components/Menu.vue'
import {useRoute,useRouter} from 'vue-router'
import api from '../common/http.js';
import {isNull,showMessage,disLabel} from '../common/utils.js'
import KfCard from '../components/KfCard.vue'
import JjrCard from '../components/JjrCard.vue'
import ProductTipCard from '../components/ProductTipCard.vue';

const kfcomp = ref(null)
const jjrcomp=ref(null)
const producttipcomp=ref(null)

function showProductTip(){
  producttipcomp.value.showProductTip();
}

function showJjr(){
  jjrcomp.value.showJjr()
}

function showKf(){
  kfcomp.value.showKf();
}

let route=useRoute()
let router=useRouter()
let menuIndex={index:1}

let data=reactive({
  searchTxt:"",
  searchType:'01',
  typeList:[],
  productList:[]
})

let model=reactive({
    phone:"",
    yzm:""
})

let search=reactive({
  orderType:"",
  typeType:"10",
  typeCode:""
})

function clickMatch(){
  router.push({ path: '/match' })
}

function clickTypeFun(index){
  if(index==1){
    router.push({ path: '/productlist' })
  }else{
    showProductTip();
  }
}

function clickFun(index){
  if(index==1){
    router.push({ path: '/producttable' })
  }else if(index==2){
    clickMatch();
  }else if(index==3){
    router.push({ path: '/shop' })
  }else if(index==5){
    router.push({ path: '/share' })
  }
}

function clickSearchTitle(){
  if(data.searchType=="01"){
    //查方案
    clickMatch();
  }else if(data.searchType=="02"){
    //查产品 
    router.push({ path: '/productlist' })
  }else if(data.searchType=="03"){
    //查进度
    router.push({ path: '/search' })
  }
}

function clickProductItem(item){
  router.push({ path: '/productdetail',query:{"productCode":item.product_code,"productChannelCode":item.product_channel_code} })
}

function changeType(type){
  if(type=="02"){
    router.push({ path: '/productlist' })
  }else if(type=="03"){
    router.push({ path: '/search' })
  }
  // data.searchType=type;
}

function clickSearch(key,value){
  if(search[key]==value){
    return;
  }
  search[key]=value;
  searchProduct();
}


function searchType(){
  api.post("/web/type/typelist",{typeType:"10"}).then((res)=>{
        // console.log(JSON.stringify(res))
        if(res.errcode=="0"){
          data.typeList=res.rows;
        }else{
          showMessage(res.errmsg);
        }
  })
}

function searchProduct(){
  api.post("/web/product/productlist",search).then((res)=>{
        // console.log(JSON.stringify(res))
        if(res.errcode=="0"){
          data.productList=res.rows;
        }else{
          showMessage(res.errmsg);
        }
  })
}

searchType();
searchProduct();
</script>
<style scoped lang="scss">
.match-product{
    margin-left:0px;
    margin-right:0px;
    padding: 1rem;
    background: #eff1f2;
    .match-product-item{
        padding:1rem;
        background: #fff;
        margin-top:1rem;
        border-radius: 1rem;

        .item-news{
            border: 30px solid #c90100;
            height: 0;
            width: 0;
            border-right-color: transparent;
            border-bottom-color: transparent;
            position: absolute;
            margin-left: -1rem;
            margin-top: -1rem;
            border-top-left-radius: 1rem;
            .item-news-title{
                margin-left: -1.3rem;
                margin-top: -1.3rem;
                color: #fff;
            }
        }

        .item-hr{
            height: 1px;
            background: #f3f3f3;
            margin-top:0.3rem;
            margin-bottom:0.3rem;
        }
        .item-label{
            margin-top:1rem;
            margin-left:2rem;
            margin-right:2rem;
            font-size:0.9rem;
            .item-label-div{
                margin-bottom:0.5rem;
                display:flex;
                img{
                    width:1.2rem;
                    height:1.2rem;
                }
                div{
                    margin-left:0.4rem;
                }
            }
        }
        .item-top{
            display:flex;
            .item-top-img{
                width:4rem;
                height:4rem;
            }
            .item-top-desc{
                margin-left:1rem;
                flex:1;
                .item-back{
                    margin-top:0.5rem;
                    font-size:1rem;
                    width:100%;
                    .item-back-desc{
                        display: inline-block;
                        color:#3D6FFF;
                        border:1px solid #3D6FFF;
                        padding-left:0.3rem;
                        padding-right:0.3rem;
                        margin-right:0.5rem;
                        border-radius:0.3rem;
                        margin-bottom: 0.3rem;
                    }
                }
                .item-prop{
                    color:#949999;
                    font-size:1rem;
                    width:100%;
                    .item-prop-desc{
                        display: inline-block;
                        margin-right:1rem;
                        margin-top:0.5rem;
                        .red{
                            margin-left:0.2rem;
                            color:#C90000;
                        }
                        .black{
                            margin-left:0.2rem;
                            color:#0A1E3C;
                        }
                    }
                }
                .item-name{
                    display:flex;
                    .item-name-name{
                        font-weight:500;
                    }
                    .item-name-desc{
                        margin-left:auto;
                        font-size:0.8rem;
                        margin-left:auto;
                        color:#3D6FFF;
                    }
                }
                .item-warn{
                    background: #fcefe5;
                    color: #d21616;
                    padding-left: 0.3rem;
                    padding-right: 0.3rem;
                    border-radius: 0.2rem;
                    display: inline;
                }
            }
        }
    }
}
.match-center-type{
    margin:1rem;
    .match-center-type-name{
        font-size:0.9rem;
    }
    .match-center-type-type1{
        overflow-x:auto;   
    }
    .match-center-type-type2{
        
        // white-space:nowrap;
        font-size:0.9rem;
    
        .btn{
            display:inline-block;
            // padding:0.2rem;
            line-height:1.5rem;
            padding-left:1rem;
            padding-right:1rem;
            
            &.sel{
                background:#3D6FFF;
                color:#fff;
                border-radius:1rem;
            }
        }
    }
    .match-center-type-type{
        display: flex;
        font-size:0.9rem;
        
        .ml{
            margin-left:0.5rem;
        }
    
        .btn{
            padding-left:1.3rem;
            padding-right:1.3rem;
            &.sel{
                background:#3D6FFF;
                color:#fff;
                border-radius:1rem;
            }
        }
        .change-div{
            display:flex;
            margin-left:auto;
            .change-img{
                margin-top:0.2rem;
                height:1rem;
            }
            .change-name{
                margin-left:0.2rem;
                color:#3D6FFF;
            }
        }
    }
}

.con-title{
    display: flex;
    margin:1rem;
    margin-top: 1.5rem;
    .con-title-bg-img{
        margin-left:1rem;
        flex: 1;
        .con-title-bg-img-img{
            margin-left: auto;
            text-align: right;
            img{
                width: 1.2rem;
            }
        }
        
        .con-title-bg{
            height:0.5rem;
            background: #e9ebeb;
            border-radius: 0.5rem;
            border-top-right-radius: 0;
        }
        
    }
    .con-title-detail{
        font-weight: 800;
        font-size:1.3rem;
        padding-top: 0.3rem;
        span{
          margin-top:auto;
        }
    }
    .con-title-detail-sub{
        color: #949999;
        margin-top: auto;
        margin-left: 1rem;
        font-size: 0.8rem;
    }
    .con-title-desc{
        margin-left: auto;
        color:#3D6FFF;
        font-size:0.8rem;
    }
}
.dt{
    margin-top:0.5rem;
    display:flex;
    margin-left:1rem;
    margin-right:1rem;
    color: #fff;
    .dt4{
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        .sp{
            margin-top: 0.5rem;
            padding-top:0.3rem;
            padding-bottom:0.3rem;
            width:1px;
            height:0.3rem;
            background: #fff;
        }
    }
    .dt1{
        text-align:center;
        font-size:1rem;
    }
    .dt2{
        padding-top:0.3rem;
        padding-bottom:0.3rem;
        &.act{
            font-weight:bold;
            font-size:1.3rem;
            color:#fff;
        }
    }
    .dt3{
        &.act{
            height:0.2rem;
            background:#fff;
            margin-left:1rem;
            margin-right:1rem;
            border-radius:0.15rem;
        }
    }
}

.banner{
  width:100%;
  height:auto;
}

.search{
    position: absolute;
    bottom: 0px;
    right: 0px;
    left: 0px;
}

.divlight{
    position: absolute;
    display: flex;
    left: 1rem;
    right: 1rem;
    top: 1rem;
    .light{
        width: 3rem;
        height: 2.8rem;
    }
    .light_desc{
        color: #fff;
        margin-left: 1rem;
        .name{
            font-size: 1.2rem;
        }
        .desc{
            font-size: 0.8rem;
        }
    }
    .light_kf{
      margin-left:auto;
      margin-top:0.5rem;
      img{
        width: 7rem;
      }
    }
}

.app{
    .ml{
        margin-left:0.5rem;
    }
    .app-con{
        display: flex;
        margin-left:1rem;
        margin-right:1rem;

        .app-sp{
          flex:1;
        }
        
        .app-item{
            text-align: center;
            // flex:1;
            border-radius: 1rem;
            height: 5rem;
            align-items:center;
            img{
                width:4rem;
                flex:1;
            }
            .app-title{
                text-align: center;
                font-size: 0.8rem;
            }
        }
    }
  
}

.service{
  .ml{
    margin-left:0.5rem;
  }
  

  .service-con{
    display: flex;
    margin-left:1rem;
    margin-right:1rem;
    
    .service-item{
      &.bg1{
        background: url(../assets/img/index/service_company.png);
        background-size: 100% 100%;
      }
      &.bg2{
        background: url(../assets/img/index/service_people.png);
        background-size: 100% 100%;
      }
      &.bg3{
        background: url(../assets/img/index/service_flow.png);
        background-size: 100% 100%;
      }
      &.bg4{
        background: url(../assets/img/index/service_lock.png);
        background-size: 100% 100%;
      }
      flex:1;
      
      border-radius: 1rem;
      display: flex;
      height: 5rem;
      align-items:center;
      img{
        margin-left:1rem;
        width: 2rem;
        height: 2rem;
      }
      .service-item-title{
        margin-left: 0.5rem;
        .title1{
          font-size: 1rem;
          font-weight: bold;
        }
        .title2{
          margin-top:0.1rem;
          font-size: 0.8rem;
          color: grey;
        }
      }
      // background: url(@/assets/img/index/service_company.png);
    }
  }
  .service-title{
    text-align: center;
    color: #0071BC;
    line-height: 2rem;
    align-items: center;
    font-weight: 500;
    margin-left: 1rem;
    font-size: 1.1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .service-title2{
    text-align: center;
    color: #848E9D;
    line-height: 2rem;
    align-items: center;
    font-weight: 500;
    margin-left: 1rem;
    font-size: 1.1rem;
    padding-top: 4rem;
  }

  .service-title3{
    text-align: center;
    color: #949999;
    line-height: 2rem;
    align-items: center;
    margin-left: 1rem;
    font-size: 0.9rem;
    margin-bottom: 2rem;
  }
}

.customer{
  .customer-con{
    margin:1rem;
    margin-left:2rem;
    margin-right:2rem;
    .customer-con-div{
      height:1.8rem;
      padding: 0.5rem;
      display: flex;
      justify-items: center;
      justify-content: center;
      line-height:1.8rem;
      color:#DCCCEC;
      
      .customer-con-div-name{
        display: flex;
        justify-content: center;
        justify-items: center;
        flex: 2;
        img{
          height: 1.4rem;
          margin-top:0.2rem;
        }
        div{
          vertical-align: middle;
          margin-left: 0.5rem;
        }
      }
      .customer-con-div-phone{
        justify-items: center;
        justify-content: center;
        display: flex;
        flex: 3;
      }
      .customer-con-div-time{
        text-align: center;
        vertical-align: middle;
        flex: 2;
      }

      &.on{
        color:#5000A0;
        background: #DCCCEC;
        border-radius: 1.3rem;
        .lineh{
          margin-top: 0.4rem;
          width:1px;
          height: 1rem;
          background: #5000A0;
        }
      }
    }
  }
  .customer-title-sub{
    text-align: center;
    color: #5000A0;
    line-height: 2rem;
    align-items: center;
    font-weight: 500;
    margin-left: 1rem;
    font-size: 1.1rem;
    margin-top: 2rem;
  }
  .customer-title{
    margin-top:2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .customer-label{
      color: #5000A0;
      line-height: 2rem;
      align-items: center;
      font-weight: 500;
      margin-left: 1rem;
      font-size: 1.1rem;
      a{
        // background: blue;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
        margin-left: 0.2rem;
        margin-right: 0.2rem;
        color: #fff;
        border-radius: 0.3rem;
        font-size:1.3rem;
        background: -webkit-linear-gradient(left top, #5000A0 , #0071BC); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(bottom right, #5000A0, #0071BC); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(bottom right, #5000A0, #0071BC); /* Firefox 3.6 - 15 */
        background: linear-gradient(to bottom right, #5000A0 , #0071BC); /* 标准的语法 */
      }
    }
  }
}

.fa-title{
  margin:auto;
  text-align: center;
  font-size: 1.2rem;
  color: #225fb1;
}
.fa{
  margin: 1.2rem;
  .fa-btn{
    
  }
  .mt{
    margin-top:0.5rem;
  }
  .fa-div{
    background: #fff;
    // border: 1px solid #949999;
    border-radius: 2rem;
    padding-left: 1rem;
    padding-right: 1rem;
    display: flex;
    align-items:center;
    .fa-div-label{
      margin:0.8rem;
      color:#afb4bd;
    }
    img{
      width: 1rem;
      height: 1.3rem;
      vertical-align: middle;
    }
  }

  .fa-div-yzm{
    display: flex;
  }
  .fa-chk{
    img{
      width:1rem;
    }
  }

  .fa-div-radio{
    margin-top:1rem;
    padding-left:1rem;
    display: flex;
    align-items: center;
    .fa-radio{
      width:0.8rem;
      height:0.8rem;
      border: 1px solid #ddd;
      border-radius: 50%;
      .fa-sel{
        width:0.6rem;
        height:0.6rem;
        margin:0.1rem;
        border-radius: 50%;
        background: #4372f6;
      }
    }
    .fa-label{
      font-size: 0.9rem;
      margin-left: 0.5rem;
      color:#0A1E3C;
    }
    .fa-label-xy{
      font-size: 0.7rem;
      margin-left: 0.5rem;
      color:#afb4bd;
      a{
        color:#3D6FFF;
      }
    }

     
  }

  .hr{
    background: #ddd;
    height:1px;
  }

  .van-field__control{
    margin-left: 0.5rem;
  }
}
</style>
